import './DailyOverviewChart.css'
import { Chart, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import { Line } from 'react-chartjs-2';
import useQuarantinedTestsHistory from '../../hooks/useQuarantinedTestsHistory';

Chart.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const QuarantineTimelineChart = ({ selectedUnit = 'All units' }) => {
    const { chartData, loading } = useQuarantinedTestsHistory(selectedUnit);
    const { dates, counts, rawData } = chartData;

    const data = {
        labels: dates,
        datasets: [
            {
                label: 'Quarantined Tests',
                data: counts,
                borderColor: '#F44336',
                backgroundColor: 'rgba(244, 67, 54, 0.1)',
                borderWidth: 2,
                fill: true,
                tension: 0.3,
                pointBackgroundColor: '#F44336',
                pointBorderColor: '#fff',
                pointBorderWidth: 2,
                pointRadius: 4,
                pointHoverRadius: 6,
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                backgroundColor: 'rgba(0, 0, 0, 0.8)',
                titleColor: '#fff',
                bodyColor: '#fff',
                borderColor: '#F44336',
                borderWidth: 1,
                callbacks: {
                    label: function(context) {
                        if (selectedUnit === 'All units') {
                            const index = context.dataIndex;
                            const item = rawData[index];
                            return [
                                ` Total: ${context.parsed.y} tests`,
                                '',
                                `Error & Surveys: ${item.error_and_surveys}`,
                                `Screen Insights: ${item.screen_insights}`,
                                `Session Replay: ${item.session_replay}`
                            ];
                        }
                        return `${context.parsed.y} tests`;
                    }
                }
            }
        },
        scales: {
            x: {
                grid: {
                    display: false,
                },
                ticks: {
                    maxTicksLimit: 8,
                    font: {
                        size: 11
                    }
                }
            },
            y: {
                beginAtZero: true,
                grid: {
                    color: 'rgba(0, 0, 0, 0.1)',
                },
                ticks: {
                    font: {
                        size: 11
                    },
                    callback: function(value) {
                        return Math.floor(value);
                    }
                }
            }
        },
        interaction: {
            intersect: false,
            mode: 'index',
        },
    };

    return (
        <div className="empty-card empty-card--wide">
            <div className="metric-header">
                <h2>History</h2>
            </div>
            <div className="chart-box" style={{ position: 'relative', width: '95%', height: '80%' }}>
                {loading ? (
                    <div style={{ 
                        display: 'flex', 
                        justifyContent: 'center', 
                        alignItems: 'center', 
                        height: '100%',
                        color: '#666'
                    }}>
                        Loading...
                    </div>
                ) : (
                    <Line data={data} options={options} />
                )}
            </div>
        </div>
    );
};

export default QuarantineTimelineChart;